import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// import { AiOutlineCloseCircle } from 'react-icons/ai';

import succesImg from 'assets/images/evi-success-modal.webp';

import Modal from 'components/Modal';
import SolidButton from 'components/SolidButton';

import './complete-session-activity-modal.scss';

const modalProps = {
  content: {
    bottom: 0,
    top: 'auto',
    transform: 'translate(-50%, 0)',
    width: '100%',
    maxWidth: 480,
    padding: '16px 0',
    borderRadius: '12px 12px 0 0',
  },
};

const CompleteSessionActivityModal = ({ modalIsOpen, toggleModal, completeSession }) => {
  const { t } = useTranslation();

  return (
    <Modal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      modalProps={modalProps}
      modalIsOpen={modalIsOpen}
      closeModal={toggleModal}
      closeable={false}
    >
      <section className="complete-session">
        {/* <AiOutlineCloseCircle className="complete-session_closeicon" onClick={toggleModal} /> */}
        <img src={succesImg} alt="UI background" className="complete-session_bgimage" />
        <h2 className="complete-session_title">{t('evieApp.exercises.sessionCompleted.title')}</h2>
        <p className="complete-session_content">{t('evieApp.exercises.sessionCompleted.content')}</p>
        <div className="complete-session_btn">
          <SolidButton className="evie-survey" onClick={completeSession}>
            {t('button.ok')}
          </SolidButton>
        </div>
      </section>
    </Modal>
  );
};

CompleteSessionActivityModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  completeSession: PropTypes.func.isRequired,
};

export default CompleteSessionActivityModal;
